import capitalize from '@/mixins/capitalize'
export default {
    mixins: [capitalize],

    methods: {
        toLocation(value, less = false) {
            if (!less) {
                return `${value.address ? value.address + ', ' : ''}${value.city ? this.capitalize(value.city) + ', ' : ''}${
                    value.state ? this.capitalize(value.state) : ''
                }${value.country ? ', ' + this.capitalize(value.country) : ''}${value.zip ? ', ' + this.capitalize(value.zip) : ''}`
            } else return `${value.state ? this.capitalize(value.state) : ''}${value.country ? ', ' + this.capitalize(value.country) : ''}`
        },
    },
}
